import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import { adCopyStrategyTargetGroupLabels } from "../../../../../../../../label/ad-copy/activity";
import type { Choice } from "../../../../../../../../react-components/lu-component/src/index";
import { Checkboxes } from "../../../../../../../../react-components/lu-component/src/index";
import { adCopyOtherConcernsOptions } from "../../../../../../../../server/models/ad-copy/activity";
import type { TrueAdCopyStrategyGroup } from "../../../../../../types/ad-copy/activity";
import { AccordionForm } from "../../../../../parts/accodion-form";

type Props = {
	onChange: (name: keyof TrueAdCopyStrategyGroup, value: any) => void;
	strategyGroup: TrueAdCopyStrategyGroup;
};

export const AdCopyOtherConcernsCheckboxes = React.memo((props: Props) => {
	const { onChange, strategyGroup } = props;

	return (
		<Row>
			<FormGroup as={Col} md={6}>
				<AccordionForm
					defaultShow={strategyGroup.otherConcerns != null && 0 < strategyGroup.otherConcerns.length}
					eventKey="otherConcerns"
					title={adCopyStrategyTargetGroupLabels.otherConcerns ?? ""}
				>
					<Checkboxes
						checkeds={strategyGroup.otherConcerns ?? []}
						choices={adCopyOtherConcernsOptions as Choice[]}
						name="otherConcerns"
						onChange={(values) => {
							onChange("otherConcerns", values);
						}}
					/>
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
